var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path3, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 211,
    viewBox: "0 0 435 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.988 1.16211C387.988 1.16211 456.852 18.7986 425.939 61.6689C395.025 104.539 315.857 46.4744 275.393 95.8566C234.929 145.239 377.433 209.816 377.433 209.816",
    stroke: "url(#paint0_linear_1794_55302)",
    strokeWidth: 0.976792
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    filter: "url(#filter0_f_1794_55302)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "url(#paint1_radial_1794_55302)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "url(#paint2_radial_1794_55302)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "url(#paint3_radial_1794_55302)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "url(#paint4_radial_1794_55302)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 329.47 74.6022)",
    fill: "#28A7CF",
    fillOpacity: 0.84,
    style: {
      mixBlendMode: "color-burn"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8343 49.7305C27.8343 49.7305 -21.4256 159.348 13.7601 187.838C48.9458 216.328 148.472 132.758 234.175 169.116C319.878 205.474 377.433 209.816 377.433 209.816",
    stroke: "url(#paint5_linear_1794_55302)",
    strokeWidth: 0.976792
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    filter: "url(#filter1_f_1794_55302)"
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "url(#paint6_radial_1794_55302)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "url(#paint7_radial_1794_55302)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "url(#paint8_radial_1794_55302)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "url(#paint9_radial_1794_55302)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 11.7911 184.22)",
    fill: "#28A7CF",
    fillOpacity: 0.84,
    style: {
      mixBlendMode: "color-burn"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.373 9.57349C224.373 9.57349 108.26 90.1588 143.446 118.649C178.631 147.138 251.265 70.8943 336.968 107.253C422.671 143.611 377.433 209.816 377.433 209.816",
    stroke: "url(#paint10_linear_1794_55302)",
    strokeWidth: 0.976792
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    filter: "url(#filter2_f_1794_55302)"
  }, _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "url(#paint11_radial_1794_55302)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "url(#paint12_radial_1794_55302)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "url(#paint13_radial_1794_55302)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "url(#paint14_radial_1794_55302)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.7198,
    ry: 3.7591,
    transform: "matrix(0.948327 -0.317295 -0.276096 -0.96113 154.546 123.985)",
    fill: "#28A7CF",
    fillOpacity: 0.84,
    style: {
      mixBlendMode: "color-burn"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1794_55302",
    x: 323.079,
    y: 68.087,
    width: 12.7827,
    height: 13.0304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35666,
    result: "effect1_foregroundBlur_1794_55302"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1794_55302",
    x: 5.39973,
    y: 177.705,
    width: 12.7827,
    height: 13.0304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35666,
    result: "effect1_foregroundBlur_1794_55302"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1794_55302",
    x: 148.154,
    y: 117.469,
    width: 12.7827,
    height: 13.0304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35666,
    result: "effect1_foregroundBlur_1794_55302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1794_55302",
    x1: 377.432,
    y1: -15.1178,
    x2: 294.62,
    y2: 226.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49444,
    stopColor: "#2824E4",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.396779 2.24629) rotate(72.5569) scale(12.5417 7.67806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.98576 8.89349) rotate(-94.0673) scale(13.0062 4.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30073 8.43506) rotate(-102.251) scale(13.3696 5.54476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37ECE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.88225 -4.44675) rotate(102.577) scale(15.1243 6.43149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1794_55302",
    x1: -102.605,
    y1: 62.2117,
    x2: 384.178,
    y2: 197.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43229,
    stopColor: "#3424E4",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.396779 2.24629) rotate(72.5569) scale(12.5417 7.67806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.98576 8.89349) rotate(-94.0673) scale(13.0062 4.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30073 8.43506) rotate(-102.251) scale(13.3696 5.54476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37ECE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.88225 -4.44675) rotate(102.577) scale(15.1243 6.43149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1794_55302",
    x1: 132.136,
    y1: -2.6364,
    x2: 393.619,
    y2: 198.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43229,
    stopColor: "#24ABE4",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.396779 2.24629) rotate(72.5569) scale(12.5417 7.67806)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.98576 8.89349) rotate(-94.0673) scale(13.0062 4.9677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30073 8.43506) rotate(-102.251) scale(13.3696 5.54476)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37ECE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1794_55302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.88225 -4.44675) rotate(102.577) scale(15.1243 6.43149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.8d73955122175a3ea700d29324fbf9b0.svg";
export { ForwardRef as ReactComponent };